import { createTracker } from 'usage-tracker';
import events from 'ui-addon-calendars/events.yaml';
const usageTracker = createTracker({
  events
});
export function trackCalendarInteraction({
  action,
  total,
  viewType
}) {
  usageTracker.track('calendarInteraction', {
    action,
    total,
    viewType
  });
}